import * as _ from 'lodash';
import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { select, Store } from '@ngrx/store';
import { selectCurrentAuctionItem } from '../../features/auction.selectors';
import { ModalAuctionDetailService } from '../../services/modal-auction-detail/modal-auction-detail.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-auction-item-card',
  templateUrl: './auction-item-card.component.html',
  styleUrls: ['./auction-item-card.component.scss']
})
export class AuctionItemCardComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  @Input() auctionItem
  @Input() auction

  // public AuctionStatusBiddingOpen = 0
  // public AuctionStatusBiddingPaused = 1
  // public AuctionStatusFinalized = 2
  // public OnlineBiddingNotEnabled = 3
  // public OnlineBiddingTypeLive = 4

  public img = '/images/org_logo_default_v2.svg'
  public soldOut = null

  public soldCount = 0;

  public auctionStatus = null;
  public auctionType = null;

  public currentItem$ = this.store.pipe(
    select(selectCurrentAuctionItem),
    takeUntilDestroyed()
  );

  constructor(
    public auctionManageService: AuctionManageService,
    private store: Store,
    private modalAuctionDetailService: ModalAuctionDetailService
  ) { }

  ngOnInit(): void {
    const { auctionItem } = this;
    if(auctionItem){
      this.img = this.auctionItem.imageUrl ? this.auctionItem.imageUrl : "/images/org_logo_default_v2.svg";

      const soldItems = _.isNull(auctionItem.soldItems) ? []: auctionItem.soldItems
      this.soldCount = soldItems.length;
    }
    this.auctionStatus = this.auctionManageService.getAuctionStatus(this.auction)
    this.auctionType = this.auctionStatus.type
  }

  getAuctionItemStatus(){
    if(this.auction && this.auctionItem){
      let auctionStatus =  this.auctionManageService.getAuctionStatus(this.auction)
      if(this.auctionItem.status == 1) {
        return "<span class='caption red-text'>Deleted</span>"
    } else if (this.auctionItem.soldCount >= this.auctionItem.count) {
      this.soldOut = true
        return ""
    } else if(this.auctionItem.status == 0) {
        switch(auctionStatus.status) {                            
            case 0:
                return "<span class='caption green-text'>Active</span>"
            case 1:
                return "<span class='caption text-warning'>Paused</span>"
            case 2:
                return ""
            default:
                return "<span class='caption grey-text '>Unknown</span>"
        }
    }
    }

  }

  getDelivered(){
    return 0
  }

  openDetailModal(event){
    if(event.target.classList.contains('mdb-shared-popover') || event.target.classList.contains('mdb-popover')){
      return
    }

    let params = {
      campaignId : this.auction.id,
      presetId : this.auctionItem.id,
      status: this.auctionManageService.getAuctionStatus(this.auction).status,
      auctionType: this.auctionType
    }

    const data = {
      params,
      placeOfCall: 'itemDetails'
    }

    this.modalAuctionDetailService.open(data);
  }

  getNumberStr(number){
    return this.auctionManageService.addCommasToNumber(number)
  }
}
